import OrderBasketItem from './OrderBasketItem';
import RemovedItemsNotice from './RemovedItemsNotice';

export default {
  OrderBasketItem,
  RemovedItemsNotice,
};
